import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';

export interface RemoveInvestigationWatcherCommand {
  readonly investigationId: string;
  readonly userId: string;
}

@Injectable({ providedIn: 'root' })
export class RemoveInvestigationWatcherUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(command: RemoveInvestigationWatcherCommand): Observable<void> {
    return this._repository.removeWatcher(command.investigationId, command.userId).pipe(
      catchError((error) => { throw error; }),
    );
  }
}
